module.exports = __webpack_public_path__ + "img/logo-white_bg.f80d8ae6.svg";